import * as DataParams from '@/assets/js/data_params.js'

var resolveMetrikaId = function () {
    var metrikaId = DataParams.get('metrikaId');

    if (metrikaId) {
        return Number(metrikaId);
    }

    if (window.ymId) {
        return window.ymId;
    }

    if (!window.Ya || !window.Ya._metrika || !window.Ya._metrika.getCounters) {
        return null;
    }

    var counters = window.Ya._metrika.getCounters();
    return counters.length ? counters[0].id : null;
};

window.addEventListener('load', function() {
    if (!!window.ymId) {
        return;
    }

    window.ymId = resolveMetrikaId();
});

var reachGoal = function (goalName, fallbackGoalName) {
    var ymId = resolveMetrikaId();
    var goal = DataParams.get('metrikaGoal') || goalName || fallbackGoalName;

    if (ymId && goal && typeof window.ym === 'function') {
        window.ym(ymId, 'reachGoal', goal);
    }
};

/**
 * Цель на заполнение анкеты
 */
var newBid = function () {
    reachGoal('new_bid');

    if (typeof(window.gtag) !== 'undefined') {
        gtag('event','click',{'event_category':'general','event_label':'lead'});
    }
};

var cardBinding = function () {
    reachGoal('card_binding');
};

export { newBid, reachGoal, cardBinding }
